const {
  GET_ALL_FAMILLE_REQUEST,
  GET_ALL_FAMILLE_SUCCESS,
  GET_ALL_FAMILLE_FAIL,
  ADD_FAMILLE_REQUEST,
  ADD_FAMILLE_SUCCESS,
  ADD_FAMILLE_FAIL,
  UPDATE_FAMILLE_REQUEST,
  UPDATE_FAMILLE_SUCCESS,
  UPDATE_FAMILLE_FAIL,
  DELETE_FAMILLE_REQUEST,
  DELETE_FAMILLE_SUCCESS,
  DELETE_FAMILLE_FAIL
} = require("../../actionTypes/Paramaetrage/Famille");

function getAllFamilles(state = { data: {} }, action) {
  switch (action.type) {
    case GET_ALL_FAMILLE_REQUEST:
      return { loading: true, data: {} };
    case GET_ALL_FAMILLE_SUCCESS:
      return { loading: false, data: action.payload };
    case GET_ALL_FAMILLE_FAIL:
      return { loading: false, error: action.data };
    default:
      return state;
  }
}

function addFamille(state = { data: {} }, action) {
  switch (action.type) {
    case ADD_FAMILLE_REQUEST:
      return { loading: true, data: {} };
    case ADD_FAMILLE_SUCCESS:
      return { loading: false, data: action.payload };
    case ADD_FAMILLE_FAIL:
      return { loading: false, error: action.data };
    default:
      return state;
  }
}

function updateFamille(state = { data: {} }, action) {
  switch (action.type) {
    case UPDATE_FAMILLE_REQUEST:
      return { loading: true, data: {} };
    case UPDATE_FAMILLE_SUCCESS:
      return { loading: false, data: action.payload };
    case UPDATE_FAMILLE_FAIL:
      return { loading: false, error: action.data };
    default:
      return state;
  }
}

function deleteFamille(state = { data: {} }, action) {
  switch (action.type) {
    case DELETE_FAMILLE_REQUEST:
      return { loading: true, data: {} };
    case DELETE_FAMILLE_SUCCESS:
      return { loading: false, data: action.payload };
    case DELETE_FAMILLE_FAIL:
      return { loading: false, error: action.data };
    default:
      return state;
  }
}

export { addFamille, updateFamille, deleteFamille, getAllFamilles };
